import AOS from 'aos';
import initializeMobileMenu from './menu';
import initializeFancybox from './fancybox';
import initializeForms from "./form";
import initializeCollapseElements from "./collapse";
import initializeSlider from "./slider";
import initializeTwitterWidget from "./twitter";
import fixMapIframe from "./map";
import fixCookieNoticeAccessibility from "./cookie-notice";
import whatInput from 'what-input'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        AOS.init({
            disable: 'mobile',
            once: true,
            duration: 1000
        });
        initializeMobileMenu();
        initializeFancybox();
        initializeForms();
        initializeCollapseElements();
        initializeSlider();
        fixCookieNoticeAccessibility();
        initializeTwitterWidget();
        fixMapIframe();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
